import { basicTask } from "./task";
import { swiperInit } from "./swiper";
const bodyWrap = document.querySelector("body");
const sideNav = document.querySelector(".sidenav-group");
const hamburger = document.querySelector(".hamburger");
const menuMobile = document.querySelector(".mobile-nav-wrap");
const searchWrap = document.querySelector(".search-overlay");
let resizeTimeout;





document.addEventListener("DOMContentLoaded", () => {

	mappingFunc();
	swiperInit();
	basicTask();
	const observer = lozad(".lozad", {
		rootMargin: "10px 0px", // syntax similar to that of CSS Margin
		threshold: 0.1, // ratio of element convergence
		enableAutoReload: true, // it will reload the new image when validating attributes changes
	});
	observer.observe();
	window.lozadObserver = observer;
	generalFunction.init();
	try {
		const hash = window.location.hash.replace('#', ''); // "tab-block-1"

		if (!hash) return;

		// ---------- ACTIVATE TAB CONTENT ----------
		const tabContent = document.getElementById(hash);
		if (tabContent) {
			document.querySelectorAll(".tab-item.active").forEach(el => {
				el.classList.remove("active");
			});
			tabContent.classList.add("active");
		}

		// ---------- ACTIVATE TAB NAV ----------
		const activeNav = document.querySelector(`.tab-nav li a[data-type="${hash}"]`);
		if (activeNav) {
			document.querySelectorAll(".tab-nav li.active").forEach(el => {
				el.classList.remove("active");
			});
			activeNav.parentElement.classList.add("active");
		}
	} catch (error) {

	}
});


window.addEventListener("resize", function () {
	// Clear any existing timeout. If the user resizes again within
	// the 0.5s, the previous delayed execution will be cancelled.
	clearTimeout(resizeTimeout);

	// Set a new timeout. The functions inside will only execute
	// if no new 'resize' event occurs for 500 milliseconds (0.5 seconds).
	resizeTimeout = setTimeout(() => {
		let width = this.window.innerWidth;
		if (width <= 1200.1) {
			mappingFunc();
			generalFunction.init();
		}
	}, 1000); // 500 milliseconds = 0.5 seconds
});
window.addEventListener("scroll", function () {
	const width = this.window.innerWidth;
	const scrollTop = window.scrollY || document.documentElement.scrollTop;
	if (width >= 1200.1) {
		if (
			document.body.scrollTop > 100 ||
			document.documentElement.scrollTop > 100
		) {
			bodyWrap.classList.add("minimize");
		} else {
			bodyWrap.classList.remove("minimize");
		}
	}
	if (scrollTop > window.innerHeight) {
		sideNav.classList.add("show");
	} else {
		sideNav.classList.remove("show");
	}
});
document.addEventListener("click", (event) => {
	if (!event.target.closest(".search-toggle, .search-overlay")) {
		searchWrap.classList.remove("is-open");
	}
	if (!event.target.closest(".mobile-nav-wrap, .site-menu-toggle")) {
		menuMobile.classList.remove("is-open");
		bodyWrap.classList.remove("overlay-bg");
		hamburger.classList.remove("is-active");
	}
});

Fancybox.bind("[data-fancybox]", {
	parentEl: document.body[0], // Element containing main structure
});


$("body").on("click", ".contact-network .item", function (e) {
	let map = $(this).attr("data-map");
	let title = $(this).attr("data-title");
	let link = $(this).attr("data-link");
	$(".contact-network .item").removeClass("is-active");
	$(this).addClass("is-active");
	$(".map-wrap iframe").attr("src", map);
	$(".contact-network .title-wrap .heading-4").text(title);
	$(".contact-network .title-wrap .btn").attr("href", link);
});

const generalFunction = {

	scrollReveal: () => {
		if ($(window).width() > 1200.1) {
			// Function to process custom attributes
			function revealWithAttributes(selector, baseConfig) {
				document.querySelectorAll(selector).forEach((element) => {
					// Read custom attributes
					const delay = element.getAttribute("data-delay") || baseConfig.delay;
					const duration = element.getAttribute("data-duration") || baseConfig.duration;
					const distance = element.getAttribute("data-distance") || baseConfig.distance;

					// Create a new configuration based on custom attributes
					const config = {
						...baseConfig,
						delay: parseInt(delay, 10),
						duration: parseInt(duration, 10),
						distance: distance,
					};

					// Apply ScrollReveal
					ScrollReveal().reveal(element, { mobile: false, once: true, ...config, easing: "cubic-bezier(0.5, 0, 0, 1)" });

					// Trigger animation for elements already in viewport
					const rect = element.getBoundingClientRect();
					if (rect.top < window.innerHeight && rect.bottom >= 0) {
						ScrollReveal().reveal(element, config);
					}
				});
			}

			// Base configurations
			let fadeDown = { origin: "top", duration: 1000, delay: 200, distance: "20px", interval: 50, reset: false };
			let fadeUp = { origin: "bottom", duration: 1000, delay: 200, distance: "20px", interval: 50, reset: false };
			let fadeLeft = { origin: "left", duration: 1000, delay: 200, distance: "25%", interval: 150, reset: false };
			let fadeRight = { origin: "right", duration: 1000, delay: 200, distance: "25%", interval: 150, reset: false };
			let fadeIn = { origin: "top", duration: 1100, delay: 220, distance: 0, interval: 150, reset: false };

			// Call the function for each selector
			revealWithAttributes(".fd-down", fadeDown);
			revealWithAttributes(".fd-up", fadeUp);
			revealWithAttributes(".fd-left", fadeLeft);
			revealWithAttributes(".fd-right", fadeRight);
			revealWithAttributes(".fd-in", fadeIn);
		}

	},
	a11yUser: () => {
		const wrapForms = document.querySelectorAll(".wrap-form");
		wrapForms.forEach(function (form) {
			const submitInput = form.querySelector("input[type='submit']");
			const labelFor = submitInput.getAttribute("name");
			const labelSubmit = form.querySelector(".frm-btnwrap .label");
			if (labelFor !== null) {
				if (labelSubmit !== null) {
					labelSubmit.textContent = "Submit Button";
					labelSubmit.setAttribute("for", labelFor);
				}
			}
		});
	},
	hideElement: () => {
		if ($(window).width() < 1200.1) {
			[".searchbox", ".nav-primary-menu"]
				.map((selector) => document.querySelector(selector))
				.forEach((el) => (el.style.display = "flex"));
		}
	},

	figureImage: () => {
		if ($(".fullcontent iframe").length) {
			$(".fullcontent iframe").wrap(
				"<div class='iframe-ratio'></div>"
			);
		}

	},
	init: () => {
		generalFunction.figureImage();
		generalFunction.scrollReveal();
		generalFunction.hideElement();
	},
};




function mappingFunc() {

}
